import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import AnimatedBg from './AnimatedBg';
import { LG, MD } from 'crm-activity-creator-data/types/ActivityButtonProps';
import { BUTTON_MARGIN, LARGE_BUTTON_WIDTH, MEDIUM_BUTTON_WIDTH } from '../../constants/ButtonConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMinInlineSize = size => {
  let pixels;
  switch (size) {
    case LG:
      pixels = LARGE_BUTTON_WIDTH + BUTTON_MARGIN;
      break;
    case MD:
      pixels = MEDIUM_BUTTON_WIDTH + BUTTON_MARGIN;
      break;
    default:
      pixels = MEDIUM_BUTTON_WIDTH;
  }
  return `${pixels}px`;
};
const ActivityButtonSkeleton = ({
  size
}) => {
  const buttonSize = size === LG ? '40px' : '32px';
  const minInlineSize = getMinInlineSize(size);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    as: "li",
    minInlineSize: minInlineSize,
    children: [/*#__PURE__*/_jsx(View, {
      "data-test-id": "create-activity-buttons-shiny-skeleton-circle",
      blockSize: buttonSize,
      inlineSize: buttonSize,
      borderRadius: "full",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(AnimatedBg, {})
    }), /*#__PURE__*/_jsx(View, {
      blockSize: "12px",
      inlineSize: buttonSize,
      borderRadius: "100",
      marginBlockStart: "200",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(AnimatedBg, {})
    })]
  });
};
export default ActivityButtonSkeleton;